export const SCREEN_XL = 1280;
export const SCREEN_LG = 1080;
export const SCREEN_XMD = 800;
export const SCREEN_MD = 640;
export const SCREEN_SM = 320;
